var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"index"}},[_c('play-video'),_c('count-year'),_c('card-col-4'),_c('main-full-banner'),_c('quick-menu'),_c('my-feed-insta'),_c('pop-up'),_c('main-notice')],1)}
var staticRenderFns = []

export { render, staticRenderFns }